<script>
import bem from '@/utils/bem';
import PagesHeaderSelector from '@/components/ux/PagesHeaderSelector/pages-header-selector.vue';
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  DeleteOutlined,
  EditOutlined,
} from '@ant-design/icons-vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import { mapActions, mapState } from 'vuex';
import createDebounce from '@/utils/debounce';
import PromoSteps from '@/pages/promotions/promoSteps/Promo-steps.vue';
import PromoTexts from '@/pages/promotions/promoTexts/Promo-texts.vue';
import { v4 as uuidv4 } from 'uuid';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import urlToFile from '@/utils/urlToFile';
import constants from './constants';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
const b = bem('promotional-ads');
const DEFAULT_STEPS = [
  {
    name: 'Step 1',
    desktopImage: '',
    mobileImage: '',
    title: 'Step 1 title',
    subtitle: 'Step 1 subtitle',
    body: 'Step 1 body text',
    buttonText: 'Step 1 button text',
    disclaimerText: 'Step 1 disclaimer text',
    hideStep: true,
    textBox1: '',
    textBox2: '',
  },
  {
    name: 'Step 2',
    desktopImage: '',
    mobileImage: '',
    title: 'Step 2 title',
    subtitle: 'Step 2 subtitle',
    body: 'Step 2 body text',
    buttonText: 'Step 2 button text',
    disclaimerText: 'Step 2 disclaimer text',
    hideStep: true,
    textBox1: '',
    textBox2: '',
  },
  {
    name: 'Step 3',
    desktopImage: '',
    mobileImage: '',
    title: 'Step 3 title',
    subtitle: 'Step 3 subtitle',
    body: 'Step 3 body text',
    buttonText: 'Step 3 button text',
    disclaimerText: 'Step 3 disclaimer text',
    hideStep: true,
    textBox1: '',
    textBox2: '',
  },
];

export default {
  components: {
    PromoTexts,
    PromoSteps,
    DeleteOutlined,
    PagesHeaderSelector,
    EyeOutlined,
    EyeInvisibleOutlined,
    EditOutlined,
  },
  data() {
    return {
      debounce: createDebounce(),
      days: 30,
      selectedInterval: ['', ''],
      options: constants.OPTIONS,
      selectedPage: {
        label: 'Digitize',
        value: 'digitize',
        path: 'media-digitizing-service',
      },
      calendarDate: dayjs.tz(dayjs(), 'America/New_York'),
      currentPagePromosections: [],
      promoAdTitle: '',
      selectedPromoAdTemplate: null,
      isNewPromoAd: true,
      selectedPromotionalAd: null,
      showPromoCodeInBanner: false,
      promoCodesList: [],
      selectedPromoCode: null,
      promotionalAdActiveIntervals: [],
      isStartValidate: true,
      bannerText: '',
      mobileBannerText: '',
      dropDownText: '',
      countDownText: '',
      countDown: false,
      isIncludeBanner: true,
      steps: DEFAULT_STEPS,
      checkedStep: { value: 0, label: 'Step 1' },
      stepsList: [{ value: 0, label: 'Step 1' }, { value: 1, label: 'Step 2' }, { value: 2, label: 'Step 3' }],
      errors: {
        desktopImage: false,
        mobileImage: false,
        title: false,
        subtitle: false,
        body: false,
        // buttonText: false,
        disclaimerText: false,
        textBox1: false,
        textBox2: false,
      },
      loadPageWithAdvertisement: false,
      availablePromosections: [],
      isEditName: false,
      adTemplateList: [],
      isHidePromoData: true,
      selectedFirstDate: null,
      blockedDates: null,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getPromoSectionsAction: 'promotions/getPromoSections',
      copyPromoSectionsAction: 'promotions/copyPromoSections',
      searchPromoCodesAction: 'promotions/searchPromoCodes',
      createPromoAdAction: 'promotions/createPromoAd',
      updatePromoSectionAction: 'promotions/updatePromoSection',
      updatePromoSectionBannerAction: 'promotions/updatePromoSectionBanner',
      addNewDatesForPromoAdAction: 'promotions/addNewDatesForPromoAd',
      deletePromoSectionDateIntervalAction: 'promotions/deletePromoSectionDateInterval',
      getPagesListAction: 'collections/getPagesList',
      getPromoTemplatesAction: 'promotions/getPromoTemplates',
      getCategoriesAction: 'blogs/getCategories',
      getProductsActions: 'products/getProducts',
      getProductCollectionsActions: 'products/getProductCollections',
    }),
    copyAds() {
      const value = {
        startDate: dayjs.tz(this.selectedInterval[0], 'America/New_York').$d,
        endDate: dayjs.tz(this.selectedInterval[1], 'America/New_York').$d,
        addDays: this.days,
        key: this.selectedPage.path,
      };
      const promoSection = {
        startDate: dayjs.tz(dayjs(dayjs(this.calendarDate).subtract(1, 'month')).startOf('month'), 'America/New_York').$d,
        endDate: dayjs.tz(dayjs(dayjs(this.calendarDate).add(1, 'month')).endOf('month'), 'America/New_York').$d,
        key: this.selectedPage.path,
      };
      this.copyPromoSectionsAction({ copy: value, promoSection });
    },
    getDayData(date) {
      const dates = this.currentPagePromosections.reduce((acc, cur) => [...acc, ...cur.dates], []);
      return dates && dates.length ? dates.some(
        (item) => dayjs(dayjs.tz(date, 'America/New_York')).isBetween(item.startDate, item.endDate, null, '[]'),
      ) : false;
    },
    getPromoSection(date, key) {
      const startDay = dayjs.tz(dayjs(dayjs(date).subtract(1, 'year')).startOf('month'), 'America/New_York').$d;
      const endDay = dayjs.tz(dayjs(dayjs(date).add(1, 'year')).endOf('month'), 'America/New_York').$d;
      this.getPromoSectionsAction({
        startDate: startDay,
        endDate: endDay,
        key,
      });
    },
    isNewPromoToggle() {
      this.isNewPromoAd = !this.isNewPromoAd;
    },
    showPromoCodeInBannerToggle() {
      this.showPromoCodeInBanner = !this.showPromoCodeInBanner;
    },
    selectPromoCode(_, option) {
      this.selectedPromoCode = option;
    },
    addInterval() {
      this.promotionalAdActiveIntervals = [
        ...this.promotionalAdActiveIntervals,
        {
          id: uuidv4(),
          isError: true,
          dates: [
            '',
            '',
          ],
        },
      ];
    },
    disabledDate(current) {
      // Can not select days before today and today
      const isDateAvailable = !this.selectedPromoCode
        || (this.selectedPromoCode?.activeIntervals || []).some(
          (interval) => dayjs(current).isBetween(interval.startDate, interval.endDate, 'day', '[]'),
        );
      const pickedIntervals = this.promotionalAdActiveIntervals
        .filter((interval) => interval && interval.dates && interval.dates[0] && interval.dates[1]);
      const isDateAlreadyPicked = pickedIntervals.some(
        (interval) => dayjs(current).isBetween(interval.dates[0], interval.dates[1], 'day', '[]'),
      );
      return !isDateAvailable || isDateAlreadyPicked;
    },
    getBlockedDate(date) {
      if (!this.blockedDates) {
        return false;
      }
      const {
        blockBefore,
        blockAfter,
      } = this.blockedDates;
      const current = dayjs(date);
      return current.isBefore(blockBefore) || current.isAfter(blockAfter);
    },
    changeDate(dates, index, interval) {
      const isDateRangeAvailable = !this.selectedPromoCode || this.selectedPromoCode?.activeIntervals.some((item) => dayjs(dates[0]).isBetween(item.startDate, item.endDate, 'day', '[]')
        && dayjs(dates[1]).isBetween(item.startDate, item.endDate, 'day', '[]'));
      if (isDateRangeAvailable) {
        const takedIntervals = this.promotionalAdActiveIntervals.reduce((acc, item) => {
          if (item.id !== interval.id && item.dates[0] && item.dates[1]) {
            return [
              ...acc,
              {
                startDate: item.dates[0],
                endDate: item.dates[1],
              },
            ];
          }
          return acc;
        }, []);

        const isDatesTaked = takedIntervals.some((itm) => dayjs(dates[0]).isBetween(itm.startDate, itm.endDate, 'day', '[]')
          || dayjs(dates[1]).isBetween(itm.startDate, itm.endDate, 'day', '[]'));

        if (isDatesTaked) {
          return;
        }

        this.promotionalAdActiveIntervals = this.promotionalAdActiveIntervals.map(
          (item) => {
            if (item.id === interval.id) {
              return {
                id: item.id,
                isError: false,
                dates,
              };
            }
            return item;
          },
        );
      }
    },
    deleteDate(interval) {
      this.promotionalAdActiveIntervals = this.promotionalAdActiveIntervals.filter(
        (item) => item.id !== interval.id,
      );
      if (typeof interval.id === 'number') {
        this.deletePromoSectionDateIntervalAction(interval.id);
      }
    },
    isStepDisabled() {
      return Object.values(this.errors).some((itm) => itm);
    },
    async submit() {
      const promoAd = {
        title: this.promoAdTitle,
        banner: {
          countDown: this.countDown,
          countDownText: this.countDownText,
          dropDownText: this.dropDownText,
          mobileDropDownText: this.mobileBannerText,
          text: this.bannerText,
        },
        css: {},
        dates: this.promotionalAdActiveIntervals.reduce((acc, item) => {
          const { dates } = item;
          const value = {
            startDate: dayjs.utc(dayjs(dates[0]).startOf('day')).$d,
            endDate: dayjs.utc(dayjs(dates[1]).endOf('day')).$d,
          };
          return [...acc, value];
        }, []),
        includeAdvertisementWithBanner: this.isIncludeBanner,
        isShowInBanner: this.showPromoCodeInBanner,
        key: this.selectedPage.path,
        loadPageWithAdvertisement: this.loadPageWithAdvertisement,
        promoCodeId: this.selectedPromoCode.id,
        steps: this.steps,
      };
      if (this.isNewPromoAd) {
        this.createPromoAdAction({
          value: promoAd,
          promosectionsParams: {
            startDate: dayjs.tz(dayjs(dayjs(this.calendarDate).subtract(1, 'year')).startOf('month'), 'America/New_York').$d,
            endDate: dayjs.tz(dayjs(dayjs(this.calendarDate).add(1, 'year')).endOf('month'), 'America/New_York').$d,
            key: this.selectedPage.path,
          },
          resetData: this.resetData,
        });
      } else {
        const promoSection = this.promoSections.find(({ id }) => id === this.selectedPromotionalAd);

        // update steps for promo ad
        const stepsImages = this.steps
          .reduce((acc, step) => [...acc, step.desktopImage, step.mobileImage], []);

        const uploadedImages = await Promise.all(stepsImages.map(async (image) => {
          if (image && image.length && image?.[0]?.file) {
            const formData = new FormData();
            formData.append('file', image[0].file);
            formData.append('folder', 'default');
            const promiseData = await apiCall({
              type: 'POST',
              headers: { 'content-type': 'multipart/form-data' },
              url: URLS.fileUpload,
              body: formData,
              isToken: true,
            });
            return promiseData;
          }
          return { data: { data: { url: image?.[0]?.url || (typeof image === 'string' ? image : image[0] || '') } } };
        }));

        const newSteps = this.steps.map(({
          addedAt,
          updatedAt,
          ...step
        }, index) => {
          if (index === 0) {
            return {
              ...step,
              desktopImage: uploadedImages[0].data.data.url,
              mobileImage: uploadedImages[1].data.data.url,
            };
          }
          if (index === 1) {
            return {
              ...step,
              desktopImage: uploadedImages[2].data.data.url,
              mobileImage: uploadedImages[3].data.data.url,
            };
          }
          return {
            ...step,
            desktopImage: uploadedImages[4].data.data.url,
            mobileImage: uploadedImages[5].data.data.url,
          };
        });

        await Promise.all(newSteps.map(({ id: itemId, ...item }) => apiCall({
          type: 'PUT',
          url: `${URLS.promoSections}/content/${itemId}`,
          body: item,
          isToken: true,
        })));

        // update main data of promo section
        this.updatePromoSectionAction({
          id: this.selectedPromotionalAd,
          promo: {
            title: this.promoAdTitle,
            css: {},
            promoCodeId: this.selectedPromoCode.id,
            includeAdvertisementWithBanner: this.isIncludeBanner,
            isShowInBanner: this.showPromoCodeInBanner,
            loadPageWithAdvertisement: this.loadPageWithAdvertisement,
          },
        });

        // update banner section of promo section
        this.updatePromoSectionBannerAction({
          id: promoSection.banner.id,
          banner: {
            countDown: this.countDown,
            countDownText: this.countDownText,
            dropDownText: this.dropDownText,
            mobileDropDownText: this.mobileBannerText,
            text: this.bannerText,
          },
          resetData: this.resetData,
        });

        // add new dates for promo ad
        const newDates = this.promotionalAdActiveIntervals.reduce((acc, item) => {
          if (typeof item.id !== 'number') {
            const { dates } = item;
            return [...acc, {
              startDate: dayjs.tz(dayjs.utc(dayjs(dates[0]).startOf('day')), 'America/New_York').$d,
              endDate: dayjs.tz(dayjs.utc(dayjs(dates[1]).endOf('day')), 'America/New_York').$d,
              promoSectionId: promoSection.id,
            }];
          }
          return acc;
        }, []);
        this.addNewDatesForPromoAdAction({ dates: newDates });
      }
    },
    calendarOnClick(id) {
      this.selectedPromotionalAd = id;
      this.isNewPromoAd = false;
    },
    selectDateInterval(date) {
      if (this.selectedFirstDate) {
        const isEarlier = dayjs(date).isBefore(dayjs(this.selectedFirstDate));
        this.addInterval();
        const lastInterval = this.promotionalAdActiveIntervals.length - 1;
        this.changeDate(
          [
            isEarlier ? date : this.selectedFirstDate,
            isEarlier ? this.selectedFirstDate : date,
          ],
          lastInterval,
          this.promotionalAdActiveIntervals[lastInterval],
        );
        this.selectedFirstDate = null;
      } else {
        this.selectedFirstDate = date;
        // const firstDisabledDate = dayjs(date);
      }
      this.selectedPromotionalAd = null;
      this.isNewPromoAd = true;
    },
    isEditNameToggle(value) {
      this.isEditName = value;
    },
    getCurrentDayInfo(current) {
      return this.currentPagePromosections.find((item) => (
        item.dates.some((date) => (
          dayjs(date.startDate).isBefore(current)
          && dayjs(date.endDate).isAfter(current)
        ))));
    },
    resetData() {
      this.promoAdTitle = '';
      this.countDown = false;
      this.countDownText = '';
      this.dropDownText = '';
      this.mobileBannerText = '';
      this.bannerText = '';
      this.promotionalAdActiveIntervals = [];
      this.isIncludeBanner = false;
      this.showPromoCodeInBanner = false;
      this.loadPageWithAdvertisement = false;
      this.steps = DEFAULT_STEPS;
      this.selectedPromoCode = null;
      this.isNewPromoAd = true;
    },
    filterOption(input, option) {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
  },
  computed: {
    ...mapState({
      promoSections: (state) => state.promotions.promoSections,
      promoCodes: (state) => state.promotions.promoCodes,
      pageList: (state) => state.collections.collectionsPages,
      adTemplates: (state) => state.promotions.templates,
      categoriesList: (state) => state.blogs.categoriesList,
    }),
  },
  mounted() {
    this.getPromoSection(this.calendarDate, this.selectedPage.path);
    this.searchPromoCodesAction({ limit: 99999, offset: 0 });
    this.getPagesListAction();
    this.getPromoTemplatesAction();
    this.getCategoriesAction();
    this.getProductsActions();
    this.getProductCollectionsActions();
  },
  watch: {
    selectedPage: {
      handler(newVal) {
        if (newVal.path) {
          this.getPromoSection(this.calendarDate, newVal.path);
        }
      },
      deep: true,
    },
    selectedFirstDate: {
      handler(newValue) {
        if (!newValue) {
          this.blockedDates = null;
          return;
        }

        const allIntervals = [
          ...this.currentPagePromosections.reduce((acc, cur) => [...acc, ...cur.dates], []),
          ...this.promotionalAdActiveIntervals.map((item) => (item.dates)),
        ].map((interval) => ({
          startDate: dayjs(interval.startDate || interval[0]),
          endDate: dayjs(interval.endDate || interval[1]),
        })).sort((a, c) => a.startDate - c.startDate);

        const selectedDate = dayjs.tz(newValue, 'America/New_York');
        this.blockedDates = allIntervals.reduce((acc, { startDate, endDate }) => {
          if (selectedDate.isBefore(startDate) && acc.blockAfter === null) {
            acc.blockAfter = startDate;
          } else if (selectedDate.isAfter(endDate)) {
            acc.blockBefore = endDate;
          }
          return acc;
        }, { blockBefore: null, blockAfter: null });
      },
      deep: true,
    },
    calendarDate: {
      handler(newVal) {
        this.getPromoSection(newVal, this.selectedPage.path);
      },
      deep: true,
    },
    promoSections: {
      handler(newVal) {
        const startOfMonth = dayjs.tz(dayjs(this.calendarDate).startOf('month'), 'America/New_York');
        const endOfMonth = dayjs.tz(dayjs(this.calendarDate).endOf('month'), 'America/New_York');
        this.currentPagePromosections = newVal.filter(({ key, dates }) => (
          key === this.selectedPage.path
          && dates.some((item) => (
            dayjs(item.startDate).isBetween(startOfMonth, endOfMonth, 'day', '[]')
            || dayjs(item.endDate).isBetween(startOfMonth, endOfMonth, 'day', '[]')
            || (
              dayjs(item.startDate).isBefore(startOfMonth)
              && dayjs(item.endDate).isAfter(endOfMonth)
            )
          )))) || [];
        this.availablePromosections = newVal.reduce((acc, item) => {
          const section = constants.ALL_PAGE_KEYS.find(({ path }) => path === item.key);
          if (section) {
            return [
              ...acc,
              {
                label: `${item.title} - (${constants.ALL_PAGE_KEYS.find(({ path }) => path === item.key).label})`,
                value: item.id,
              },
            ];
          }
          return acc;
        }, []).sort((a, c) => a.label.localeCompare(c.label));
      },
      deep: true,
    },
    promoCodes: {
      handler(newVal) {
        this.promoCodesList = newVal.map((item) => (
          {
            ...item,
            label: item.name,
            value: item.name,
          }
        )).sort((a, c) => a.label.localeCompare(c.label));
      },
      deep: true,
    },
    promotionalAdActiveIntervals: {
      handler(newVal) {
        function isPromotionalIntervalInPromoCodeInterval(promotionalInterval, promoCodeIntervals) {
          return promoCodeIntervals.some(({ startDate, endDate }) => ((
            promotionalInterval.startDate.isAfter(startDate)
            || promotionalInterval.startDate.isSame(startDate)
          ) && (
            promotionalInterval.endDate.isBefore(endDate)
            || promotionalInterval.endDate.isSame(endDate)
          )
          ));
        }

        this.promoCodesList = this.promoCodesList
          .filter((promoCode) => newVal
            .every((promotionalInterval) => promotionalInterval.dates.every((interval) => {
              const promoInterval = {
                startDate: dayjs(interval[0]),
                endDate: dayjs(interval[1]),
              };
              return isPromotionalIntervalInPromoCodeInterval(
                promoInterval,
                promoCode.activeIntervals,
              );
            })));
      },
      deep: true,
    },
    steps: {
      handler() {
        const step = this.steps[this.checkedStep.value];
        if (!step.hideStep) {
          this.errors = Object.keys(this.errors).reduce((acc, key) => ({
            ...acc,
            [key]: !step[key],
          }), {});
        } else {
          this.errors = {
            desktopImage: false,
            mobileImage: false,
            title: false,
            subtitle: false,
            body: false,
            // buttonText: false,
            disclaimerText: false,
            textBox1: false,
            textBox2: false,
          };
        }
      },
      deep: true,
    },
    selectedPromotionalAd: {
      async handler(newValue) {
        if (newValue) {
          const promoSection = this.promoSections.find(({ id }) => id === newValue);
          this.promoAdTitle = promoSection.title;
          this.countDown = promoSection.banner.countDown;
          this.countDownText = promoSection.banner.countDownText;
          this.dropDownText = promoSection.banner.dropDownText;
          this.mobileBannerText = promoSection.banner.mobileDropDownText;
          this.bannerText = promoSection.banner.text;
          this.promotionalAdActiveIntervals = promoSection.dates.map((date) => (
            { id: date.id, isError: false, dates: [dayjs.utc(date.startDate).tz('America/New_York'), dayjs.utc(date.endDate).tz('America/New_York')] }
          ), {}, []);
          this.isIncludeBanner = promoSection.includeAdvertisementWithBanner;
          this.showPromoCodeInBanner = promoSection.isShowInBanner;
          this.loadPageWithAdvertisement = promoSection.loadPageWithAdvertisement;
          const steps = promoSection.steps.sort((a, c) => a.name.split(' ')[1] - c.name.split(' ')[1]);

          this.steps = steps && steps.length > 0
            ? await Promise.all(steps.map(async (item) => (
              {
                ...item,
                desktopImage: item.desktopImage ? [{
                  status: 'done',
                  uid: uuidv4(),
                  url: item.desktopImage,
                  file: item.desktopImage ? await urlToFile(item.desktopImage, 'desktopImage.jpeg') : null,
                }] : item.desktopImage || [],
                mobileImage: item.mobileImage ? [{
                  status: 'done',
                  uid: uuidv4(),
                  url: item.mobileImage,
                  file: item.mobileImage ? await urlToFile(item.mobileImage, 'desktopImage.jpeg') : null,
                }] : item.mobileImage || [],
              })))
          // .sort((a, c) => a.name[a.name.length - 1] - c.name[c.name.length - 1])
            : DEFAULT_STEPS;
          this.selectedPromoCode = this.promoCodesList.find(
            ({ id }) => id === promoSection.promoCodeId,
          ) || null;
          this.isNewPromoAd = false;
        } else {
          this.resetData();
        }
      },
      deep: true,
    },
    selectedPromoAdTemplate: {
      async handler(newValue) {
        const promoSection = this.adTemplateList.find(({ id }) => id === newValue);
        this.promoAdTitle = this.promoAdTitle || promoSection.label;
        this.countDown = promoSection.banner.countDown;
        this.countDownText = promoSection.banner.countDownText;
        this.dropDownText = promoSection.banner.dropDownText;
        this.mobileBannerText = promoSection.banner.mobileDropDownText;
        this.bannerText = promoSection.banner.text;
        this.isIncludeBanner = false;
        this.steps = promoSection.steps
          ? await Promise.all(promoSection.steps
            .map(({
              name,
              mobileImage,
              title,
              subtitle,
              body,
              buttonText,
              disclaimerText,
              hideStep,
              desktopImage,
              textBox1,
              textBox2,
            }) => ({
              name,
              title,
              subtitle,
              body,
              buttonText,
              disclaimerText,
              hideStep,
              textBox1,
              textBox2,
              desktopImage: desktopImage ? [{
                status: 'done',
                uid: uuidv4(),
                url: desktopImage,
                file: null,
              }] : desktopImage || [],
              mobileImage: mobileImage ? [{
                status: 'done',
                uid: uuidv4(),
                url: mobileImage,
                file: null,
              }] : mobileImage || [],
            }))
            .sort((a, c) => a.name[a.name.length - 1] - c.name[c.name.length - 1]))
          : DEFAULT_STEPS;
        this.isNewPromoAd = true;
      },
      deep: true,
    },
    categoriesList: {
      handler(newValue) {
        const newOptions = newValue.map((item) => {
          const { url, name, id } = item;
          return {
            label: name,
            value: `blogCategory_${id}`,
            path: url,
          };
        });

        this.options = {
          ...this.options,
          blogCategory: {
            title: 'Blog Category',
            key: 'blogCategory',
            options: newOptions,
          },
        };
      },
    },
    pageList: {
      handler(newValue) {
        this.options = newValue.reduce((acc, item) => {
          if (['photo_art', 'photo_restoration', 'pm_cart', 'printed_story', 'proof'].includes(item)) {
            return acc;
          }
          return {
            ...acc,
            commercial: {
              ...acc.commercial,
              options: [...acc.commercial.options, {
                label: `${item.replaceAll('_', ' ')}`,
                value: `pod?pageKey=${item}`,
                path: `pod?pageKey=${item}`,
              }],
            },
          };
        }, this.options);
      },
      deep: true,
    },
    adTemplates(value) {
      this.adTemplateList = value
        .map((item) => ({ ...item, label: item.name, value: item.id }))
        .sort((a, c) => a.label.localeCompare(c.label));
    },
  },
};
</script>

<template>
  <div :class="b('')">
    <div :class="b('row')">
      <div :class="b('copy-promotional-wrap')">
        <a-range-picker
          v-model:value="selectedInterval"
          :placeholder="['Start Date', 'End Date']"
        />
        <a-input-number :class="b('days-input')" v-model:value="days" :min="1" :max="999" />
        <a-button
          :class="b('copy-btn')"
          type="primary"
          html-type="button"
          @click="copyAds"
          :disabled="!selectedPage.path || !selectedInterval[0] || !selectedInterval[1]"
        >
          Copy ads
        </a-button>
      </div>
      <PagesHeaderSelector v-model:selected-page="selectedPage" :options="options" />
    </div>
  </div>
  <div :class="b('main-block')">
    <div :class="b('left-side')">
      <a-calendar
        v-model:value="calendarDate"
      >
        <template #dateFullCellRender="{ current }">
          <div :class="b('calendar-badge-wrap')">
            <span :class="b('calendar-cell-date')">{{current.$D}}</span>
            <button
              v-if="getDayData(current)"
              :class="b('calendar-badge')"
              @click="this.calendarOnClick(getCurrentDayInfo(current)?.id)"
            >
              {{ getCurrentDayInfo(current)?.title }}
            </button>
            <div
              v-else-if="
                ((
                  selectedPromoCode?.activeIntervals
                  || promotionalAdActiveIntervals.length
                ) && disabledDate(current))
                || (selectedFirstDate && getBlockedDate(current))
              "
              :class="b('calendar-badge', {disable: true})"
            >
              unavailable date
            </div>
            <button
              v-else
              :class="b('calendar-badge', {free: true})"
              @click="() => {
                selectDateInterval(current)
              }"
            >
              Free date
            </button>
          </div>
        </template>
      </a-calendar>
    </div>
    <div :class="b('right-side')">
      <template v-if="promotionalAdActiveIntervals.length">
        <div :class="b('row')">
          <div :class="b('field-wrap')">
            <div :class="b('field-title-wrap')">
              <span :class="b('field-title')">Promo ad title:</span>
              <div :class="b('field-title-buttons', {hide: true})">
                <button
                    :class="b('field-title-button', { on: isNewPromoAd })"
                    @click="() => {
                      isNewPromoToggle();
                      isEditNameToggle(false);
                    }"
                >
                  New
                </button>
                /
                <button
                    :class="b('field-title-button', { on: !isNewPromoAd })"
                    @click="() => {
                      isNewPromoToggle();
                      isEditNameToggle(false);
                    }"
                >
                  Saved
                </button>
              </div>
            </div>
            <a-input
                :class="b('field-input')"
                v-model:value="promoAdTitle"
                v-if="isNewPromoAd || isEditName"
            />
            <a-select
                v-else
                :class="b('field-select')"
                :options="availablePromosections"
                placeholder="Select saved promo ad"
                v-model:value="selectedPromotionalAd"
            />
            <button
                v-if="!isNewPromoAd"
                :class="b('field-select-button')"
                @click="() => {
                    isEditNameToggle(!isEditName);
                  }"
            >
              <EditOutlined
                :fill="'#77899888'"
              />
            </button>
          </div>
          <div :class="b('field-wrap')">
            <span :class="b('field-title')">Ad template:</span>
            <a-select
              :class="b('field-select')"
              :options="adTemplateList"
              placeholder="Select promo ad template"
              v-model:value="selectedPromoAdTemplate"
              show-search
              :filter-option="filterOption"
              not-found-content="Not Found"
            />
          </div>
        </div>
        <div :class="b('row')">
          <div :class="b('field-wrap')">
            <div :class="b('field-title-wrap')">
              <span :class="b('field-title')">Promo code:</span>
              <div :class="b('field-title-buttons')">
                Show in banner:
                <button
                    :class="b('field-title-button', { on: showPromoCodeInBanner })"
                    @click="showPromoCodeInBannerToggle"
                >
                  <EyeOutlined />
                </button>
                /
                <button
                    :class="b('field-title-button', { on: !showPromoCodeInBanner })"
                    @click="showPromoCodeInBannerToggle"
                >
                  <EyeInvisibleOutlined />
                </button>
              </div>
            </div>
            <a-select
              :class="b('field-select')"
              :options="promoCodesList"
              placeholder="Select promo code"
              :value="selectedPromoCode"
              @change="selectPromoCode"
              show-search
            />
          </div>
        </div>
        <div :class="b('center')">
          <a-button
            :class="b('promo-setting-button')"
            type="primary"
            ghost
            html-type="button"
            @click="isHidePromoData = !isHidePromoData"
          >
            {{ isHidePromoData ? 'Show promo settings' : 'Hide promo settings' }}
          </a-button>
        </div>
        <template v-if="!isHidePromoData">
          <div :class="b('column', { h200: true })">
            <div :class="b('row')">
              <div
                :class="b('field-wrap')"
                v-for="(activeInterval, index) in promotionalAdActiveIntervals"
                :key="index"
              >
                <span :class="b('field-title')">Promo section interval:</span>
                <div :class="b('row')">
                  <a-range-picker
                    :value="activeInterval.dates"
                    :placeholder="['Start Date', 'End Date']"
                    :disabled-date="disabledDate"
                    @change="(dates) => {
                      changeDate(dates, index, activeInterval)
                    }"
                  />
                  <a-button
                    type="primary"
                    size="small"
                    html-type="button"
                    danger
                    @click="() => {
                      deleteDate(activeInterval)
                    }"
                  >
                    <DeleteOutlined />
                  </a-button>
                </div>
                <span
                    :class="b('field-error')"
                    v-if="activeInterval.isError && isStartValidate"
                >Date interval wrong</span>
              </div>
            </div>
            <a-button
                :class="b('field-button')"
                type="primary"
                html-type="button"
                @click="addInterval"
            >
              Add new interval
            </a-button>
          </div>
          <PromoTexts
            v-model:banner-text="bannerText"
            v-model:mobile-banner-text="mobileBannerText"
            v-model:drop-down-text="dropDownText"
            v-model:count-down-text="countDownText"
            v-model:count-down="countDown"
            v-model:is-include-banner="isIncludeBanner"
            :is-hide-include-banner-toggle="true"
            :isHidePromoData="isHidePromoData"
          />
          <div
            :class="b('column', {hide: isHidePromoData})"
            v-if="isIncludeBanner"
          >
            <PromoSteps
              :option-steps="stepsList"
              :is-disabled-step="isStepDisabled()"
              v-model:checked-step="checkedStep"
              v-model:checkedStepValues="steps[checkedStep.value]"
              :errors="errors"
              :isChangeFullOption="true"
              :selectedPromotionalAd="selectedPromotionalAd"
            />
          </div>
        </template>
        <div :class="b('center')">
          <a-button
              class="sort-button"
              type="primary"
              html-type="button"
              :disabled="!selectedPromoCode"
              @click="submit"
          >
            {{ isNewPromoAd ? 'Create ad' : 'Save ad' }}
          </a-button>
        </div>
      </template>
      <div v-else style="color: red">First, select the interval</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/media";

.promotional-ads {
  margin-top: 20px;

  @include mediaMinMax(1025, $normal) {
    margin-top: vw-full(20);
  }

  &__copy-promotional-wrap {
    display: flex;
    align-items: center;
    padding: 0 0 20px 20px;

    @include mediaMinMax(1025, $normal) {
      padding: 0 0 vw-full(20) vw-full(20);
    }
  }

  &__days-input {
    margin: 0 20px;

    @include mediaMinMax(1025, $normal) {
      margin: 0 vw-full(20);
    }
  }

  &__main-block {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__left-side {
    width: 45%;
    border-radius: 12px;
    margin-left: 20px;
    padding: 20px;
    box-shadow: 10.1px 12.4px 76px 0 rgba($black-color, 0.07);

    @include mediaMinMax(1025, $normal) {
      border-radius: vw-full(12);
      margin-left: vw-full(20);
      padding: vw-full(20);
    }

    .ant-picker-calendar-date {
      padding: 0 !important;
      position: relative !important;
    }
    .ant-picker-calendar-date-value {
      position: absolute !important;
    }
  }

  &__calendar-badge-wrap {
    width: 100%;
    height: 70px;
    position: relative;
    border-bottom: 1px solid $jagged-ice-color;
    cursor: pointer;
  }

  &__calendar-cell-date {
    position: absolute;
    top: 0;
    right: 10px;
  }

  &__calendar-badge {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $tacao;
    border: none;
    cursor: pointer;
    font-size: 12px;
    flex-wrap: wrap;

    &:hover {
      background-color: rgba(238, 197, 134, 0.53);
    }

    &_free {
      background-color: transparent;
      &:hover {
        background-color: rgba(0, 0, 0, 0.07);
      }
    }

    &_disable {
      background-color: rgba(255, 0, 0, 0.34);

      &:hover {
        background-color: rgba(255, 0, 0, 0.8);
      }
    }

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(12);
    }
  }

  &__right-side {
    width: 45%;
    border-radius: 12px;
    margin-right: 20px;
    padding: 20px;
    box-shadow: 10.1px 12.4px 76px 0 rgba($black-color, 0.07);

    @include mediaMinMax(1025, $normal) {
      border-radius: vw-full(12);
      margin-right: vw-full(20);
      padding: vw-full(20);
    }
  }

  &__row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__column {
    margin-bottom: 20px;

    @include mediaMinMax(1025, $normal) {
      margin-bottom: vw-full(20);
    }

    &_h200 {
      height: 200px;
      overflow-x: hidden;
      overflow-y: auto;

      @include mediaMinMax(1025, $normal) {
        height: vw-full(200);
      }
    }

    &_hide {
      display: none;
    }
  }

  &__field-wrap {
    display: flex;
    flex-direction: column;
    width: 45%;
    margin-bottom: 20px;
    position: relative;

    @include mediaMinMax(1025, $normal) {
      margin-bottom: vw-full(20);
    }
  }

  &__field-title-wrap,
  &__field-buttons {
    display: flex;
    justify-content: space-between;

  }

  &__field-title-buttons {
    &_hide {
      display: none;
    }
  }

  &__field-title-button {
    background: none;
    border: none;
    color: rgba($light-slate-gray-color, 0.5);
    cursor: pointer;

    &_on {
      color: $tacao;
    }
  }

  &__field-error {
    color: $burnt-sienna-color;
  }

  &__center {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  &__field-select-button {
    position: absolute;
    right: -30px;
    top: 25px;
    background: none;
    border: none;
    cursor: pointer;
    color: rgba($light-slate-gray-color, 0.5);
  }

  &__promo-setting-button {
    margin: 10px 0 20px;
  }
}
</style>
